import { type UseQueryResult, useQuery } from 'react-query';
import {
  NotificationTemplateService,
  Wealthlane_NotificationService_DTOs_NotificationTemplate_NotificationMatrixTemplateDto
} from '../../services/wealthlane-notification-services';

const useGetEmailTemplateById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string | null
): UseQueryResult<Wealthlane_NotificationService_DTOs_NotificationTemplate_NotificationMatrixTemplateDto | undefined, unknown> => {
  return useQuery(
    ['getEmailTemplateById', id],
    async () => {
      return await handleRequest(
        NotificationTemplateService.getApiNotificationApiAppNotificationTemplate1(id as string)
      );
    },
    {
      enabled: !!id,
      select(data) {
        return {
          isActive: data?.isActive,
          notificationType: data?.notificationType,
          message: data?.templateMessage ?? '',
        };
      },
    }
  );
};

export default useGetEmailTemplateById;
